import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";

export const adminDataRoutes = [
    {
        key: 'pages.gedung',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/gedung`,
        component: React.lazy(() => import('views/admin-views/gedung')),
    },
    {
        key: 'pages.gedung.input',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/gedung/view`,
        component: React.lazy(() => import('views/admin-views/gedung/view')),
    },
    {
        key: 'pages.gedung.edit',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/gedung/edit`,
        component: React.lazy(() => import('views/admin-views/gedung/update')),
    },
    {
        key: 'pages.gedung.add',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/gedung/add`,
        component: React.lazy(() => import('views/admin-views/gedung/add')),
    },
    {
        key: 'pages.kelas',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/ruang-kelas`,
        component: React.lazy(() => import('views/admin-views/ruang-kelas')),
    },
    {
        key: 'pages.kelas.add',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/ruang-kelas/add`,
        component: React.lazy(() => import('views/admin-views/ruang-kelas/add')),
    },
    {
        key: 'pages.kelas.edit',
        path: `${APP_PREFIX_PATH}/master-data/konfigurasi/ruang-kelas/edit/:id`,
        component: React.lazy(() =>import('views/admin-views/ruang-kelas/edit')),
    },

    // KURIKULUM
    // {
    //     key: 'pages.kurikulum',
    //     path: `${APP_PREFIX_PATH}/pages/kurikulum`,
    //     component: React.lazy(() => import('views/master-view/kurikulum')),
    // },
    // {
    //     key: 'pages.kurikulum.add',
    //     path: `${APP_PREFIX_PATH}/pages/kurikulum/add`,
    //     component: React.lazy(() => import('views/master-view/kurikulum/add')),
    // },
    // {
    //     key: 'pages.kurikulum.input',
    //     path: `${APP_PREFIX_PATH}/pages/kurikulum/view`,
    //     component: React.lazy(() => import('views/master-view/kurikulum/view')),
    // },
    // {
    //     key: 'pages.kurikulum.edit',
    //     path: `${APP_PREFIX_PATH}/pages/kurikulum/edit/:id`,
    //     component: React.lazy(() =>import('views/master-view/kurikulum/edit')),
    // },
    // KURIKULUM
    {
        key: 'pages.kurikulum',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/kurikulum`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/kurikulum')),
    },
    {
        key: 'pages.kurikulum.add',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/kurikulum/add`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/kurikulum/add')),
    },
    {
        key: 'pages.kurikulum.edit',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/kurikulum/edit/:id`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/kurikulum/edit')),
    },
     {
         key: 'pages.kurikulum.input',
         path: `${APP_PREFIX_PATH}/pages/kurikulum/view`,
         component: React.lazy(() => import('views/admin-views/perkuliahan/kurikulum/view')),
     },

    {
        key: 'pages.matkul',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/matkul`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/mata-kuliah/ShowMatkul')),
    },
    {
        key: 'pages.matkul.add',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/matkul/add`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/mata-kuliah/add')),
    },
    {
        key: 'pages.matkul.edit',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/matkul/edit/:id`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/mata-kuliah/edit')),
    },
    {
        key: 'pages.matkul.edit',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/matkul/view/:id`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/mata-kuliah/view')),
    },
    {
        key: 'pages.matkul.prasyarat',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/matkul/prasyarat/:id`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/mata-kuliah/prasyarat')),
    },
    {
        key: 'pages.matkul.sync',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/matkul/sync`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/mata-kuliah/sync')),
    },
    //////////////////////////////////////////
    {
        key: 'sync-feeder.mk-kurikulum',
        path: `${APP_PREFIX_PATH}/sync/mk-kurikulum`,
        component: React.lazy(() => import('views/admin-views/sync/mk-kurikulum')),
    },
    {
        key: 'sync-feeder.mahasiswa',
        path: `${APP_PREFIX_PATH}/sync/mahasiswa`,
        component: React.lazy(() => import('views/admin-views/sync/mahasiswa')),
    },
    {
        key: 'pages.sync',
        path: `${APP_PREFIX_PATH}/sync/log`,
        component: React.lazy(() => import('views/admin-views/sync')),
    },

    ///////////////////////////////////////////
    {
        key: 'pages.user',
        path: `${APP_PREFIX_PATH}/setting/user-akses`,
        component: React.lazy(() => import('views/admin-views/user-akses')),
    },
    {
        key: 'pages.user.add',
        path: `${APP_PREFIX_PATH}/setting/user-akses/add`,
        component: React.lazy(() => import('views/admin-views/user-akses/add')),
    },
    {
        key: 'pages.user.edit',
        path: `${APP_PREFIX_PATH}/setting/user-akses/edit`,
        component: React.lazy(() => import('views/admin-views/user-akses/edit')),
    },
    // Mata Kuliah
    {
        key: 'pages.mahasiswa',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/mahasiswa`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/mahasiswa')),
    },
    {
        key: 'pages.mahasiswa.add',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/mahasiswa/add`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/mahasiswa/edit')),
    },
    {
        key: 'pages.mahasiswa.edit',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/mahasiswa/edit/:id`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/mahasiswa/edit')),
    },
    {
        key: 'pages.mahasiswa.detail',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/mahasiswa/detail/:id`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/mahasiswa/detail')),
    },
    {
        key: 'pages.mahasiswa.actions',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/mahasiswa/actions`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/mahasiswa/actions')),
    },

    // SKALA PENILAIAN
    {
        key: 'pages.skalaPenilaian',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/skala-penilaian`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/skala-penilaian')),
    },
    {
        key: 'pages.skalaPenilaian.add',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/skala-penilaian/add`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/skala-penilaian/add')),
    },
    {
        key: 'pages.skalaPenilaian.edit',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/skala-penilaian/edit/:id`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/skala-penilaian/edit')),
    },
    {
        key: 'pages.skalaPenilaian.detail',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/skala-penilaian/detail/:id`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/skala-penilaian/detail')),
    },

    // KRS
    {
        key: 'administrasi.krs',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/krs`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/krs')),
    },
    {
        key: 'administrasi.krs.add',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/krs/add`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/krs/add')),
    },
    {
        key: 'administrasi.krs.edit',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/krs/edit/:id`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/krs/edit')),
    },
    // KRS V2 (menu baru, ADMIN & ADMIN_PRODI) — flow KRS lama di atas tidak diubah
    {
        key: 'administrasi.krs-v2',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/krs-v2`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/krs-v2')),
    },
    {
        key: 'administrasi.krs-v2.detail',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/krs-v2/:id`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/krs-v2/detail')),
    },
    // Kelas Kuliah (ADMIN & ADMIN_PRODI) — data kelas, dosen pengajar, peserta hasil sync Neofeeder
    {
        key: 'administrasi.kelas-kuliah',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/kelas-kuliah`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/kelas-kuliah')),
    },
    {
        key: 'administrasi.kelas-kuliah.detail',
        path: `${APP_PREFIX_PATH}/master-data/administrasi/kelas-kuliah/:id`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/kelas-kuliah/detail')),
    },

    //DOSEN
    {
        key: 'pages.dosen',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/dosen`,
        //component: React.lazy(() => import('views/master-view/dosen')),
        component: React.lazy(() => import('views/admin-views/perkuliahan/dosen')),
    },
    {
        key: 'pages.dosen.add',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/dosen/add`,
        component: React.lazy(() => import('views/admin-views/perkuliahan/dosen/add')),
    },
    {
        key: 'pages.dosen.edit',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/dosen/edit/:id`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/dosen/edit')),
    },
    {
        key: 'pages.dosen.input',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/dosen/view/:id`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/dosen/view')),
    },
    {
        key: 'pages.dosen.input.sign',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/dosen/sign`,
        component: React.lazy(() =>import('views/admin-views/perkuliahan/dosen/sign')),
    },

    // FAKULTAS
    {
        key: 'pages.payment',
        path: `${APP_PREFIX_PATH}/pembayaran/verifikasi`,
        component: React.lazy(() => import('views/admin-views/payment/verification')),
    },
    {
        key: 'pages.payment',
        path: `${APP_PREFIX_PATH}/pembayaran/verifikasi/detail`,
        component: React.lazy(() => import('views/admin-views/payment/verification/detail')),
    },

    // FAKULTAS
    {
        key: 'pages.fakultas',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/fakultas`,
        component: React.lazy(() => import('views/master-view/fakultas')),
    },
    {
        key: 'pages.fakultas.add',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/fakultas/add`,
        component: React.lazy(() => import('views/master-view/fakultas/add')),
    },
    {
        key: 'pages.fakultas.edit',
        path: `${APP_PREFIX_PATH}/master-data/perkuliahan/fakultas/edit/:id`,
        component: React.lazy(() =>import('views/master-view/fakultas/edit')),
    },


    // CONFIG-PEMBAYARAN
    {
        key: 'pages.fakultas',
        path: `${APP_PREFIX_PATH}/pembayaran/setting`,
        component: React.lazy(() => import('views/admin-views/payment/config-pembayaran')),
    },
    {
        key: 'pages.fakultas.edit',
        path: `${APP_PREFIX_PATH}/pembayaran/setting/edit/:id`,
        component: React.lazy(() => import('views/admin-views/payment/config-pembayaran/edit')),
    },
    {
        key: 'pages.fakultas.detail',
        path: `${APP_PREFIX_PATH}/pembayaran/setting/detail`,
        component: React.lazy(() => import('views/admin-views/payment/config-pembayaran/detail')),
    },

    // KALENDER-AKADEMIK
    {
        key: 'pages.kalender',
        path: `${APP_PREFIX_PATH}/administrasi/kalender`,
        component: React.lazy(() => import('views/admin-views/kalender-akademik')),
    },
    {
        key: 'pages.kalender.event',
        path: `${APP_PREFIX_PATH}/administrasi/kalender/event`,
        component: React.lazy(() => import('views/admin-views/kalender-akademik/event')),
    },
    {
        key: 'pages.kalender.event.add',
        path: `${APP_PREFIX_PATH}/administrasi/kalender/event/add`,
        component: React.lazy(() => import('views/admin-views/kalender-akademik/event/add')),
    },
    {
        key: 'pages.kalender.event.edit',
        path: `${APP_PREFIX_PATH}/administrasi/kalender/event/edit/:id`,
        component: React.lazy(() => import('views/admin-views/kalender-akademik/event/edit')),
    },
    {
        key: 'pages.kalender.event.detail',
        path: `${APP_PREFIX_PATH}/administrasi/kalender/event/detail`,
        component: React.lazy(() => import('views/admin-views/kalender-akademik/event/detail')),
    },
    {
        key: 'pages.kalender.akademik',
        path: `${APP_PREFIX_PATH}/administrasi/kalender/akademik`,
        component: React.lazy(() => import('views/admin-views/kalender-akademik/akademik')),
    },
    {
        key: 'pages.kalender.akademik.add',
        path: `${APP_PREFIX_PATH}/administrasi/kalender/akademik/add`,
        component: React.lazy(() => import('views/admin-views/kalender-akademik/akademik/add')),
    },
    {
        key: 'pages.kalender.akademik.edit',
        path: `${APP_PREFIX_PATH}/administrasi/kalender/akademik/edit/:id`,
        component: React.lazy(() => import('views/admin-views/kalender-akademik/akademik/edit')),
    },
    {
        key: 'pages.kalender.akademik.detail',
        path: `${APP_PREFIX_PATH}/administrasi/kalender/akademik/detail/:id`,
        component: React.lazy(() => import('views/admin-views/kalender-akademik/akademik/detail')),
    },

    // SKRIPSI
    {
        key: 'administrasi.skripsi',
        path: `${APP_PREFIX_PATH}/administrasi/skripsi`,
        component: React.lazy(() => import('views/admin-views/administrasi/skripsi')),
    },
    {
        key: 'administrasi.skripsi.seminar_proposal',
        path: `${APP_PREFIX_PATH}/administrasi/skripsi/seminar_proposal`,
        component: React.lazy(() => import('views/admin-views/administrasi/skripsi/seminar_proposal')),
    },
    {
        key: 'administrasi.skripsi.seminar_proposal.detail',
        path: `${APP_PREFIX_PATH}/administrasi/skripsi/seminar_proposal/detail`,
        component: React.lazy(() => import('views/admin-views/administrasi/skripsi/seminar_proposal/detail')),
    },

    {
        key: 'administrasi.skripsi.seminar_hasil',
        path: `${APP_PREFIX_PATH}/administrasi/skripsi/seminar_hasil`,
        component: React.lazy(() => import('views/admin-views/administrasi/skripsi/seminar_hasil')),
    },
    {
        key: 'administrasi.skripsi.seminar_hasil.detail',
        path: `${APP_PREFIX_PATH}/administrasi/skripsi/seminar_hasil/detail`,
        component: React.lazy(() => import('views/admin-views/administrasi/skripsi/seminar_hasil/detail')),
    },

    {
        key: 'administrasi.skripsi.ujian_tutup',
        path: `${APP_PREFIX_PATH}/administrasi/skripsi/ujian_tutup`,
        component: React.lazy(() => import('views/admin-views/administrasi/skripsi/ujian_tutup')),
    },
    {
        key: 'administrasi.skripsi.ujian_tutup.detail',
        path: `${APP_PREFIX_PATH}/administrasi/skripsi/ujian_tutup/detail`,
        component: React.lazy(() => import('views/admin-views/administrasi/skripsi/ujian_tutup/detail')),
    },
    {
        key: 'administrasi.pengangguhan',
        path: `${APP_PREFIX_PATH}/administrasi/pengangguhan`,
        component: React.lazy(() => import('views/admin-views/administrasi/penangguhan')),
    },
    {
        key: 'administrasi.pengangguhan.pembayaran',
        path: `${APP_PREFIX_PATH}/administrasi/pengangguhan/pembayaran`,
        component: React.lazy(() => import('views/admin-views/administrasi/penangguhan/pembayaran')),
    },
    {
        key: 'administrasi.pengangguhan.pembayaran.detail',
        path: `${APP_PREFIX_PATH}/administrasi/pengangguhan/pembayaran/detail`,
        component: React.lazy(() => import('views/admin-views/administrasi/penangguhan/pembayaran/detail')),
    },

    // konfigurasi
    {
        key: 'konfigurasi',
        path: `${APP_PREFIX_PATH}/konfigurasi`,
        component: React.lazy(() => import('views/admin-views/konfigurasi')),
    },
    {
        key: 'konfigurasi.jabatan-prodi',
        path: `${APP_PREFIX_PATH}/konfigurasi/jabatan-prodi`,
        component: React.lazy(() => import('views/admin-views/konfigurasi/jabatan-prodi')),
    },
    {
        key: 'konfigurasi.jabatan-prodi.add',
        path: `${APP_PREFIX_PATH}/konfigurasi/jabatan-prodi/add`,
        component: React.lazy(() => import('views/admin-views/konfigurasi/jabatan-prodi/add')),
    },
    {
        key: 'konfigurasi.jabatan-prodi.detail',
        path: `${APP_PREFIX_PATH}/konfigurasi/jabatan-prodi/detail`,
        component: React.lazy(() => import('views/admin-views/konfigurasi/jabatan-prodi/detail')),
    },
    {
        key: 'konfigurasi.jabatan-prodi.edit',
        path: `${APP_PREFIX_PATH}/konfigurasi/jabatan-prodi/edit`,
        component: React.lazy(() => import('views/admin-views/konfigurasi/jabatan-prodi/edit')),
    },


]